<template>
  <GameGenreDetail :genre="genre" />
</template>

<script>
import enums from '@/utilities/enums.js'
import GameGenreDetail from '@/components/GameGenreDetail.vue'


export default {
  name: 'GenreDetail',
  components: {
    GameGenreDetail,
  },
  mixins: [enums],
  props: {
    genre: {
      type: Object,
      default: () => {}
    }
  }
}
</script>
